import React from 'react';
import { FadeIn } from './FadeIn';
import { Star } from 'lucide-react';
export function ProofSection() {
  return <section className="py-16 md:py-24 bg-white" data-id="element-170">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-171">
        <FadeIn data-id="element-172">
          <div className="bg-teal-900 text-white rounded-3xl p-8 md:p-12 shadow-2xl relative overflow-hidden" data-id="element-173">
            {/* Decorative quote mark */}
            <div className="absolute -top-4 -left-4 text-9xl text-teal-800 opacity-50 font-serif leading-none" data-id="element-174">
              "
            </div>

            <div className="relative z-10" data-id="element-175">
              <div className="flex justify-center gap-1 mb-8" data-id="element-176">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-6 h-6 fill-coral text-coral" data-id="element-177" />)}
              </div>

              <h2 className="text-2xl md:text-3xl font-serif font-bold text-center mb-8 text-cream-50" data-id="element-178">
                Lo que cambia en 7 días:
              </h2>

              <p className="text-lg md:text-xl text-teal-50 leading-relaxed text-center font-medium" data-id="element-179">
                Muchas de nuestras lectoras reportan que, tras la primera sesión
                de descompresión nocturna, logran dormir 6 horas seguidas por
                primera vez en meses. Al séptimo día, la inflamación baja lo
                suficiente como para retomar caminatas suaves y tareas diarias
                sin el miedo constante al "chispazo".
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}